/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, ExtendContainerProps, ContainerProps, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Switch} from '../../../JSX/Switch';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {$RubyUIText} from '../../../JSX/RubyUIText';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {$AutoplayInput} from './AutoplayInput';

type OptionSelectorProps = ExtendContainerProps<{
    disabled?: boolean;
    action: (value: boolean) => void;
    value: boolean;
}>;

type LimitSelectorProps = ExtendContainerProps<{
    disabled?: boolean;
    action: (value: number | null) => void;
    value: number | null;
}>;

export type $AutoplayOptionsSelectorProps = ContainerProps & {
    untilBonus: OptionSelectorProps;
    singleWin: LimitSelectorProps;
    winLimit: LimitSelectorProps;
    lossLimit: LimitSelectorProps;
};

export const $AutoplayOptionsSelector: FC<$AutoplayOptionsSelectorProps> = (props) => {
    const distance = Store.computed(() => slotStore.stage_isPortrait.value ? 140 : 110);
    const singleWinPosY = Store.computed(() => distance.value * 1);
    const winLimitPosY = Store.computed(() => distance.value * 2);
    const lossLimitPosY = Store.computed(() => distance.value * 3);

    return <$Container
        {...props}
    >
        <OptionComponent name='untilBonus' textID={'autoplayStopBonus'} {...props.untilBonus} />
        <LimitComponent name='singleWin' textID={'singleWin'} y={singleWinPosY} {...props.singleWin} />
        <LimitComponent name='winLimit' textID={'winLimit'} y={winLimitPosY} {...props.winLimit} />
        <LimitComponent name='lossLimit' textID={'lossLimit'} y={lossLimitPosY} {...props.lossLimit} />
    </$Container>;
};

type LimitComponentProps = ExtendContainerProps<{
    textID: string;
}> & LimitSelectorProps;

const LimitComponent: FC<LimitComponentProps> = (props) => {
    const isValidInput = Store.signal(!!getProp(props.value));

    const effectValid = Store.effect(() => {
        isValidInput.value = !!getProp(props.value);
    });

    return <$Container
        {...props}
        events={{destroyed: [effectValid]}}
    >
        <OptionComponent
            value={isValidInput}
            disabled={Store.computed(() => !isValidInput.value)}
            action={(enabled) => {
                if (!enabled) {
                    getProp(props.action)?.(null);
                }
            }}
            textID={getProp(props.textID)}
        />
        <$AutoplayInput
            value={props.value}
            onUpdate={(value) => {
                isValidInput.value = !!value;
            }}
            onChange={(value) => {
                getProp(props.action)?.(value);
            }}
            responsive={{
                box: {x: '100%', y: '0'},
                translate: {x: '-420px', y: '-45px'},
            }}
        />
    </$Container>;
};

type OptionComponentProps = ExtendContainerProps<{
    textID: string;
}> & OptionSelectorProps;

const OptionComponent: FC<OptionComponentProps> = (props) => {
    const {value, action, textID} = props;

    return <$Container
        {...props}
    >
        <$Switch
            disabled={props.disabled}
            name='SwitchTest'
            value={value}
            action={action}
        />
        <$RubyUIText
            localeID={textID}
            position={[84, 0]}
            stylePreset='BASE'
            style={{align: 'left'}}
        />
    </$Container>;
};